import { apiGetSalaryByPersons } from "api/reportApi";
import { formatPrice } from "helpers";
import { getPersianMotnh } from "helpers/helper";

const capitalColumns = [
    {
        name: "نام پرسنل",
        key: "person",
        getValue: (item: any) => {
            return item.person?.nickName || "-";
        },
        filterParams: {
            column: "month",
            columnType: "string",
        },
    },
    {
        name: "ماه",
        key: "month",
        filterParams: {
            column: "month",
            columnType: "string",
        },
        // @ts-ignore
        getValue: (item) => {
            if (typeof item.month === "number") {
                // @ts-ignore
                return getPersianMotnh(item.month)
            }
        },
    },
    {
        name: "سال",
        key: "year",
        filterParams: {
            column: "year",
            columnType: "string",
        },
    },

    {
        name: "جمع مزایا",
        key: "debtor",
        filterParams: {
            column: "debtor",
            columnType: "number",
        },
        // @ts-ignore
        getValue: (item) => {
            return formatPrice(item.totalIncome);
        },
        searchType: "quantitative",
    },
    {
        name: "جمع کسورات",
        // @ts-ignore
        getValue: (item) => {
            return formatPrice(item.totalCost);
        },
        key: "creditor",
        filterParams: {
            column: "creditor",
            columnType: "number",
        },
        searchType: "quantitative",
    },
    {
        name: "خالص پرداختی",
        // @ts-ignore
        getValue: (item) => {
            return formatPrice(item.totalIncome - item.totalCost);
        },
        key: "creditor",
        filterParams: {
            column: "creditor",
            columnType: "number",
        },
        searchType: "quantitative",
    },

];

export const SalaryReportByPersonForm = [
    {
        key: "SalaryReportByPersonForm",
        pageTitle: "گزارش حقوق",
        tableColumns: capitalColumns,
        disableSearch: true,
        actions: {
            back: {},
            printFishSalary: {},
            fetch: apiGetSalaryByPersons,
        },
    },
];